import { createWebhookApi } from "@gs/core/domain/Webhook/createWebhookApi";
import { getBaseAxios } from "services/axios";
import { webhookStore } from "./webhookStore";
import type { Webhook, WebhookId, WebhookMetrics } from "@gs/core/domain/Webhook/Webhook";
import { dataBus } from "services/dataBus";

export const webhookApi = (() => {
  const integrationsAxios = getBaseAxios("integrations");
  const coreWebhookApi = createWebhookApi(integrationsAxios);
  const getWebhooks: typeof coreWebhookApi.getWebhooks = async (...args) => {
    const result = await coreWebhookApi.getWebhooks(...args);
    webhookStore.setState(
      result.data.data.reduce<Record<WebhookId, Webhook>>((acc, webhook) => {
        acc[webhook.uuid] = webhook;
        return acc;
      }, {}),
    );
    return result;
  };

  const getWebhookMetrics: typeof coreWebhookApi.getWebhookMetrics = async (...args) => {
    const result = await coreWebhookApi.getWebhookMetrics(...args);
    return result;
  };

  const createWebhook: typeof coreWebhookApi.createWebhook = async (...args) => {
    const result = await coreWebhookApi.createWebhook(...args);
    webhookStore.setState({
      [result.data.uuid]: result.data,
    });
    dataBus.emit("webhook:create", { webhookIds: [result.data.uuid] });
    return result;
  };

  const updateWebhook: typeof coreWebhookApi.updateWebhook = async (...args) => {
    const result = await coreWebhookApi.updateWebhook(...args);
    webhookStore.setState({
      [result.data.uuid]: result.data,
    });
    dataBus.emit("webhook:update", { webhookIds: [result.data.uuid] });
    return result;
  };

  const deleteWebhook: typeof coreWebhookApi.deleteWebhook = async (...args) => {
    const result = await coreWebhookApi.deleteWebhook(...args);
    dataBus.emit("webhook:delete", { webhookIds: [args[0].id] });
    return result;
  };

  const testWebhook: typeof coreWebhookApi.testWebhook = async (...args) => {
    const result = await coreWebhookApi.testWebhook(...args);
    return result;
  };

  return {
    getWebhooks,
    createWebhook,
    updateWebhook,
    deleteWebhook,
    getWebhookMetrics,
    testWebhook,
  };
})();
